import Api from '../api';

import { errorHandler } from '../common';
const { axios: api } = Api;
export const createInstantForm = (instantForm) =>
	errorHandler(async () => {
		const data = await api.post('/instantForm', instantForm);
		return { data: data.data };
	});

export const getInstantForms = () =>
	errorHandler(async () => {
		const data = await api.get('/instantForm');
		return { data: data.data };
	});

export const updateInstantForm = (_id, instantForm) =>
	errorHandler(async () => {
		const data = await api.put(`/instantForm/${_id}`, instantForm);
		return { data: data.data };
	});

